import type { RouteRecordRaw } from 'vue-router'

export const photoModerationRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/PhotoModerationView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'photo-moderation.page.title',
        },
        name: 'photo-moderation.index',
        path: '',
      },
    ],
    component: {
      name: 'PhotoModerationRouterView',
      template: '<router-view />',
    },
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    path: 'photo-moderation',
  },
]
